import React, { useEffect } from "react";
import { connect } from "react-redux";
import { NotificationAlertViewModal, hasSeenAlert, markAlertAsSeen } from "../components";
import * as notification from "../redux";

const NotificationAlertViewer = ({ activeAlert, viewerOpen, openViewer, closeViewer }) => {
    useEffect(() => {
        if (activeAlert && !hasSeenAlert(activeAlert)) {
            openViewer();
        } else if (!activeAlert && viewerOpen) {
            closeViewer();
        }
    }, [activeAlert]);

    const handleClose = () => {
        if (activeAlert) markAlertAsSeen(activeAlert);
        closeViewer();
    };

    return (
        <NotificationAlertViewModal
            isOpen={viewerOpen}
            alert={activeAlert}
            onClose={handleClose}
        />
    );
};

const mapStateToProps = store => ({
    activeAlert: notification.selectors.selectActiveAlert(store),
    viewerOpen: notification.selectors.selectViewerOpen(store)
});

const mapDispatchToProps = dispatch => ({
    openViewer:  () => dispatch(notification.actions.openAlertViewer()),
    closeViewer: () => dispatch(notification.actions.closeAlertViewer())
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationAlertViewer);
